import React from "react";
import Loading from "./Loading";
import { Modal, Box } from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "min-content",
    bgcolor: "none",
};

export default function PopUpModal({ open }) {
    return (
        <Modal open={open}>
            <Box sx={style}>
                <Loading />
            </Box>
        </Modal>
    );
}
